import { render, staticRenderFns } from "./UploadPic.vue?vue&type=template&id=0e79fd36&scoped=true"
import script from "./UploadPic.vue?vue&type=script&lang=js"
export * from "./UploadPic.vue?vue&type=script&lang=js"
import style0 from "./UploadPic.vue?vue&type=style&index=0&id=0e79fd36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e79fd36",
  null
  
)

export default component.exports